import { COLORS } from 'constants/colors';
import { ResourceEndpoints } from 'data/endPoints';
import { useEffect, useState } from 'react';
import useColorSetStore from 'stores/colorSet';
import useDomainStore from 'stores/domain';
import useLanguageStore from 'stores/languages';
import useMachineStore from 'stores/machine';
import useWebInfoStore from 'stores/webInfo';
import { CategoryGroup } from 'types/common/category.type';
import styles from './FacilityItem.module.scss';
import FacilityIcon from './icon/FacilityIcon';

type FacilityItemProps = {
  handleClickItem: (categoryGroup: CategoryGroup) => void;
  isActive: boolean;
  categoryGroup: CategoryGroup;
};

/**
 * FacilityItem 컴포넌트
 *
 *  2023-10-06 deprecated 마커를 그리고 첫번째 편의시설로 카메라 이동하는 기능은 더 이상 사용되지 않습니다.
 */
const FacilityItem = ({ handleClickItem, isActive, categoryGroup }: FacilityItemProps) => {
  const languageStore = useLanguageStore();
  const colorSetStore = useColorSetStore();
  const webInfoStore = useWebInfoStore();
  const machineStore = useMachineStore();
  const domainStore = useDomainStore();

  const [imageExists, setImageExists] = useState(false);

  const workspaceId = domainStore.isWeb() ? webInfoStore.webInfo?.workspace.id : machineStore.machine?.workspace.id;
  const categoryId = categoryGroup.id;
  const iconUrl = `${process.env.REACT_APP_RESOURCE_BASE_URL}${ResourceEndpoints.categoryIcon}/${workspaceId}/${categoryId}.svg`;

  useEffect(() => {
    const img = new Image();
    img.src = iconUrl;
    img.onload = () => setImageExists(true);
    img.onerror = () => setImageExists(false);
  }, [iconUrl]);

  return (
    <div
      style={{
        background: isActive ? colorSetStore.sub : 'transparent',
        borderColor: isActive ? colorSetStore.sub : colorSetStore.button.border,
        color: isActive ? COLORS.WHITE : colorSetStore.button.text,
      }}
      className={`${styles.container}`}
      onClick={handleClickItem.bind(this, categoryGroup)}
    >
      {imageExists && (
        <div className={styles.icon}>
          <FacilityIcon iconUrl={iconUrl} iconColor={isActive ? COLORS.WHITE : colorSetStore.button.text} />
        </div>
      )}

      <div className={`${styles.name} ${isActive && styles.active}`}>
        {categoryGroup.name[languageStore.currentLang]}
      </div>
    </div>
  );
};

export default FacilityItem;
